<template>
  <div class="hr-bar"></div>
</template>
<script>
export default {
  name: "hr-bar",
};
</script>
<style lang="scss" scoped>
.hr-bar {
  background-color: #e9eef3;
  height: 20px;
}
</style>
